
import axios from 'axios';
import {backendHost} from '../../../../store/config';

const postCopyWager = (params) => {
    return axios.post(`${backendHost}/api/admin/wager/copy`, params);
};

export {
    postCopyWager
}